import React from 'react';
import { changeFilter } from '../../common/services/navigation';
import PropTypes from 'prop-types';




function SearchOrderFilter({ search }) {

	const change = e => {			
		changeFilter(search, 'sort', e.target.value);
	};

	const isChecked = (key) => {
		if (search.sort === undefined)
		{
			search = {sort: "relevance"};
		}

		return search.sort && search.sort === key;
	};



	return (
		<div>
			<div className="checkbox--item section--menu_item">
				<input type="checkbox" id="relevance" checked={isChecked('relevance')} value="relevance" onChange={change}  />
				<label htmlFor="relevance">Sort by relevance</label>
			</div>	
			<div className="checkbox--item section--menu_item">
				<input type="checkbox" id="date" checked={isChecked('date')} value='date' onChange={change} />
				<label htmlFor="date">Sort by date</label>
			</div>	
		</div>
	);
}

SearchOrderFilter.propTypes = {
    search: PropTypes.object
};

export default SearchOrderFilter;
